<script lang="ts">
export default {
  name: "MainFobizzNavbarLoginOffcanvas",
};
</script>

<script setup lang="ts">
import logoUrlMobile from "/images/fobizz-logo-F.png";

type Props = {
  signupUrl: string;
};

defineProps<Props>();

const { t } = useI18n();
</script>

<template>
  <li class="nav-item d-block d-lg-none">
    <a
      class="main-fobizz-navbar__link main-fobizz-navbar__nav-icon"
      href="#"
      aria-label="Open login"
      role="button"
      data-bs-toggle="offcanvas"
      data-bs-target="#navbar-login-offcanvas"
      aria-controls="navbar-login-offcanvas"
    >
      <BaseIcon icon-name="person" color="dark" style="font-size: 1.5rem" />
    </a>
    <div
      id="navbar-login-offcanvas"
      class="offcanvas offcanvas-top login-offcanvas"
      tabindex="-1"
      aria-labelledby="navbar-login-offcanvasLabel"
    >
      <div class="offcanvas-header border-bottom">
        <h5 id="navbar-login-offcanvasLabel" class="offcanvas-title">
          <img :src="logoUrlMobile" width="40" alt="fobizz logo" />
        </h5>
        <button
          type="button"
          class="btn-close text-reset"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></button>
      </div>
      <div class="offcanvas-body small p-0">
        <a
          role="button"
          :href="signupUrl"
          class="login-offcanvas__link text-body"
        >
          <h6>{{ t("mainFobizzNavbar.signup.title") }}</h6>
          <p class="login-offcanvas__description">
            {{ t("mainFobizzNavbar.signup.text") }}
          </p>
        </a>
        <router-link
          :to="{ name: 'login' }"
          class="login-offcanvas__link text-body"
          data-testid="button-login"
        >
          <h6>{{ t("mainFobizzNavbar.teacherLogin.title") }}</h6>
          <p class="login-offcanvas__description">
            {{ t("mainFobizzNavbar.teacherLogin.text") }}
          </p>
        </router-link>

        <router-link
          :to="{ name: 'go-login' }"
          class="login-offcanvas__link text-body"
        >
          <h6>{{ t("mainFobizzNavbar.pupilLogin.title") }}</h6>
          <p class="login-offcanvas__description">
            {{ t("mainFobizzNavbar.pupilLogin.text") }}
          </p>
        </router-link>
      </div>
    </div>
  </li>
</template>

<style scoped lang="scss">
.login-offcanvas {
  &__link {
    display: flex;
    flex-direction: column;
    padding: $spacer-3 $spacer-4;
    text-decoration: none;

    &:hover {
      color: $body-color;
      background-color: $color-gray-200;
    }
  }

  &__description {
    font-size: $font-size-sm;
    font-weight: 400;
    white-space: normal;
    color: $secondary;
    margin-bottom: $spacer-1;
  }
}
</style>
